// Chakra Quiz - Single Form Submission
// Collects contact info first, then all 49 quiz answers, submits everything together

document.addEventListener('DOMContentLoaded', function() {
  initializeQuiz();
  
  // Check if we're returning from Shopify form submission
  checkForReturnFromSubmission();
});

function checkForReturnFromSubmission() {
  const formError = document.querySelector('[data-customer-form-error]');
  if (formError) {
    showScreen('contact-form');
    if (formError instanceof HTMLElement) formError.focus();
    return;
  }

  const customerPosted =
    new URLSearchParams(window.location.search).get('customer_posted') === 'true' ||
    document.querySelector('[data-customer-posted-success]');

  if (customerPosted) {
    const hasResults = loadResultsFromSession();
    showScreen('results');
    if (hasResults) {
      displayResults();
    }

    const cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.delete('customer_posted');
    cleanUrl.hash = '';
    window.history.replaceState({}, document.title, cleanUrl.pathname + cleanUrl.search);

    setTimeout(() => {
      sessionStorage.removeItem('chakraQuizResults');
    }, 1000);
  }
}

// Read chakra data from embedded JSON
const chakraDataElement = document.getElementById('chakraData');
const shopifyData = JSON.parse(chakraDataElement.textContent);

// Quiz configuration
const quizData = {
  chakras: [
    {
      id: 'root',
      name: 'Root Chakra',
      sanskrit: 'Muladhara',
      emoji: '🔴',
      color: shopifyData.colors.root,
      questions: [
        "I feel safe, secure, and grounded in my day-to-day life.",
        "I trust life and the process of being alive.",
        "I have a stable home environment and consistent financial resources.",
        "I have a healthy relationship with food and eat regularly.",
        "I rarely experience anxiety, panic attacks, or fear without clear reason.",
        "My legs, feet, lower back, and colon feel strong and healthy.",
        "I handle sudden change without feeling destabilized."
      ],
      candles: shopifyData.chakras[0].candles,
      results: shopifyData.chakras[0].results
    },
    {
      id: 'sacral',
      name: 'Sacral Chakra',
      sanskrit: 'Svadhisthana',
      emoji: '🟠',
      color: shopifyData.colors.sacral,
      questions: [
        "I am comfortable expressing my emotions openly and honestly.",
        "I feel creative and inspired regularly.",
        "I experience healthy pleasure and allow myself joy.",
        "My relationships feel emotionally fulfilling and balanced.",
        "I feel free from guilt or shame around my sexuality.",
        "My reproductive organs and lower abdomen function without issues.",
        "I maintain emotional balance, even in changing circumstances."
      ],
      candles: shopifyData.chakras[1].candles,
      results: shopifyData.chakras[1].results
    },
    {
      id: 'solar',
      name: 'Solar Plexus Chakra',
      sanskrit: 'Manipura',
      emoji: '🟡',
      color: shopifyData.colors.solar,
      questions: [
        "I feel confident and assertive in my decisions.",
        "I trust my gut instincts and follow through with action.",
        "I maintain healthy boundaries with others.",
        "I feel a sense of purpose and personal power.",
        "I digest food well and rarely experience stomach or liver issues.",
        "I am self-disciplined and can stay focused on goals.",
        "I don't often feel powerless, unmotivated, or full of doubt."
      ],
      candles: shopifyData.chakras[2].candles,
      results: shopifyData.chakras[2].results
    },
    {
      id: 'heart',
      name: 'Heart Chakra',
      sanskrit: 'Anahata',
      emoji: '💚',
      color: shopifyData.colors.heart,
      questions: [
        "I give and receive love easily and unconditionally.",
        "I forgive others and release grudges with compassion.",
        "I feel connected to others and open-hearted in relationships.",
        "I experience empathy without becoming overwhelmed.",
        "I breathe easily and have good lung and cardiovascular health.",
        "I am able to hold grief and sadness without shutting down.",
        "I feel at peace with myself and the world around me."
      ],
      candles: shopifyData.chakras[3].candles,
      results: shopifyData.chakras[3].results
    },
    {
      id: 'throat',
      name: 'Throat Chakra',
      sanskrit: 'Vishuddha',
      emoji: '💙',
      color: shopifyData.colors.throat,
      questions: [
        "I express myself clearly and authentically.",
        "I listen deeply and communicate without judgment.",
        "I feel comfortable speaking my truth, even when it's hard.",
        "I am free of chronic sore throats, thyroid issues, or jaw tension.",
        "I sing, chant, or use my voice creatively.",
        "I say 'no' when I need to without guilt.",
        "I don't hide parts of myself to please others."
      ],
      candles: shopifyData.chakras[4].candles,
      results: shopifyData.chakras[4].results
    },
    {
      id: 'thirdEye',
      name: 'Third Eye Chakra',
      sanskrit: 'Ajna',
      emoji: '💜',
      color: shopifyData.colors.thirdEye,
      questions: [
        "I trust my inner wisdom and intuition.",
        "I have a clear vision of what I want in life.",
        "I sleep well and remember dreams vividly.",
        "I am mentally sharp, focused, and clear-headed.",
        "I rarely suffer from headaches, tension, or vision problems.",
        "I can step back from emotions and see situations objectively.",
        "I feel connected to a sense of insight or inner knowing."
      ],
      candles: shopifyData.chakras[5].candles,
      results: shopifyData.chakras[5].results
    },
    {
      id: 'crown',
      name: 'Crown Chakra',
      sanskrit: 'Sahasrara',
      emoji: '🟣',
      color: shopifyData.colors.crown,
      questions: [
        "I feel connected to something greater than myself (divine, universe, source).",
        "I experience moments of deep peace or transcendence.",
        "I have faith in the timing and flow of life.",
        "I meditate or engage in spiritual practices regularly.",
        "I rarely feel chronic fatigue, migraines, or brain fog.",
        "I don't fear death and feel at peace with life's impermanence.",
        "I feel aligned with my purpose or higher calling."
      ],
      candles: shopifyData.chakras[6].candles,
      results: shopifyData.chakras[6].results
    }
  ]
};

// Quiz State
let currentChakraIndex = 0;
let answers = {};
let userData = {};
let chakraScores = [];

// Initialize answers object
quizData.chakras.forEach((chakra, index) => {
  answers[index] = new Array(7).fill(null);
});

function initializeQuiz() {
  // Start button
  const startBtn = document.querySelector('[data-action="start"]');
  if (startBtn) {
    startBtn.addEventListener('click', startQuiz);
  }
  
  // Navigation buttons
  const nextBtn = document.getElementById('nextBtn');
  const prevBtn = document.getElementById('prevBtn');
  
  if (nextBtn) nextBtn.addEventListener('click', nextChakra);
  if (prevBtn) prevBtn.addEventListener('click', prevChakra);
  
  // Form submission
  const quizForm = document.getElementById('quizForm');
  if (quizForm) {
    quizForm.addEventListener('submit', handleFormSubmit);
  }
  
  // Retake quiz
  const retakeBtn = document.getElementById('retakeQuiz');
  if (retakeBtn) {
    retakeBtn.addEventListener('click', retakeQuiz);
  }
  
  // Update total chakras
  const totalChakras = document.querySelector('.total-chakras');
  if (totalChakras) {
    totalChakras.textContent = '7';
  }
}

function startQuiz() {
  showScreen('questions');
  showChakra(0);
}

function showScreen(screenName) {
  document.querySelectorAll('.quiz-screen').forEach(screen => {
    screen.classList.remove('active');
  });
  const targetScreen = document.querySelector(`[data-screen="${screenName}"]`);
  if (targetScreen) {
    targetScreen.classList.add('active');
  }
  
  scrollToQuizTop();
}

function scrollToQuizTop() {
  const quizSection = document.getElementById('chakraQuizApp');
  if (quizSection) {
    quizSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

function showChakra(chakraIndex) {
  currentChakraIndex = chakraIndex;
  const chakra = quizData.chakras[chakraIndex];
  
  // Update progress
  const progress = ((chakraIndex + 1) / 7) * 100;
  const progressBar = document.getElementById('progressBar');
  if (progressBar) {
    progressBar.style.width = progress + '%';
  }
  
  const currentChakraEl = document.querySelector('.current-chakra');
  if (currentChakraEl) {
    currentChakraEl.textContent = chakraIndex + 1;
  }
  
  // Update chakra header
  const badge = document.getElementById('chakraBadge');
  if (badge) {
    badge.textContent = `${chakra.emoji} ${chakra.name}`;
    badge.style.background = chakra.color + '20';
    badge.style.color = chakra.color;
  }
  
  const titleEl = document.getElementById('chakraTitle');
  if (titleEl) {
    titleEl.textContent = chakra.sanskrit;
  }
  
  // Build all 7 questions
  buildAllQuestions(chakra, chakraIndex);
  
  // Update navigation buttons
  const prevBtn = document.getElementById('prevBtn');
  const nextBtn = document.getElementById('nextBtn');
  
  if (prevBtn) {
    prevBtn.style.visibility = chakraIndex === 0 ? 'hidden' : 'visible';
  }
  
  if (nextBtn) {
    nextBtn.textContent = chakraIndex === 6 ? 'Complete Quiz →' : 'Next Chakra →';
  }
  
  scrollToQuizTop();
}

function buildAllQuestions(chakra, chakraIndex) {
  const container = document.getElementById('allQuestionsContainer');
  if (!container) return;
  
  container.innerHTML = '';
  
  chakra.questions.forEach((question, qIndex) => {
    const questionBlock = document.createElement('div');
    questionBlock.className = 'question-block';
    
    questionBlock.innerHTML = `
      <div class="question-number">Question ${qIndex + 1} of 7</div>
      <div class="question-text">${question}</div>
      <div class="answer-options" data-question="${qIndex}">
        <button type="button" class="answer-btn" data-value="3" data-chakra="${chakraIndex}" data-question="${qIndex}">
          Strongly Agree
        </button>
        <button type="button" class="answer-btn" data-value="2" data-chakra="${chakraIndex}" data-question="${qIndex}">
          Agree
        </button>
        <button type="button" class="answer-btn" data-value="1" data-chakra="${chakraIndex}" data-question="${qIndex}">
          Disagree
        </button>
        <button type="button" class="answer-btn" data-value="0" data-chakra="${chakraIndex}" data-question="${qIndex}">
          Strongly Disagree
        </button>
      </div>
    `;
    
    container.appendChild(questionBlock);
  });
  
  // Restore previous answers if any
  if (answers[chakraIndex]) {
    answers[chakraIndex].forEach((answer, qIndex) => {
      if (answer !== null) {
        const btn = container.querySelector(`[data-chakra="${chakraIndex}"][data-question="${qIndex}"][data-value="${answer}"]`);
        if (btn) btn.classList.add('selected');
      }
    });
  }
  
  // Add click listeners to all answer buttons
  container.querySelectorAll('.answer-btn').forEach(btn => {
    btn.addEventListener('click', handleAnswerClick);
  });
  
  // Update submit button state
  updateSubmitButton();
}

function handleAnswerClick(e) {
  const button = e.target;
  const chakraIdx = parseInt(button.dataset.chakra);
  const questionIdx = parseInt(button.dataset.question);
  const value = parseInt(button.dataset.value);
  
  // Remove selected from siblings
  const siblings = button.parentElement.querySelectorAll('.answer-btn');
  siblings.forEach(sib => sib.classList.remove('selected'));
  
  // Add selected to clicked button
  button.classList.add('selected');
  
  // Store answer
  answers[chakraIdx][questionIdx] = value;
  
  // Update submit button
  updateSubmitButton();
}

function updateSubmitButton() {
  const nextBtn = document.getElementById('nextBtn');
  
  if (nextBtn) {
    // Enable next button if all questions answered
    const allAnswered = answers[currentChakraIndex].every(answer => answer !== null);
    nextBtn.disabled = !allAnswered;
  }
}

function nextChakra() {
  const allAnswered = answers[currentChakraIndex].every(answer => answer !== null);
  
  if (!allAnswered) {
    alert('Please answer all 7 questions before continuing.');
    return;
  }
  
  if (currentChakraIndex < 6) {
    // Move to next chakra
    showChakra(currentChakraIndex + 1);
  } else {
    // All chakras complete - show contact form
    showScreen('contact-form');
  }
}

function prevChakra() {
  if (currentChakraIndex > 0) {
    showChakra(currentChakraIndex - 1);
  }
}

function handleFormSubmit(e) {
  const form = e.currentTarget;
  const emailField = form.querySelector('[name="contact[email]"]');

  if (!emailField || !emailField.value.trim()) {
    e.preventDefault();
    showScreen('contact-form');
    if (emailField) {
      emailField.setCustomValidity('Please enter your email address.');
      emailField.addEventListener('input', () => emailField.setCustomValidity(''), { once: true });
      emailField.reportValidity();
    }
    return;
  }

  emailField.setCustomValidity('');

  // Calculate results
  calculateResults();
  
  // Store results in sessionStorage (for displaying after redirect)
  storeResultsInSession();
  
  // Populate Shopify customer fields and quiz tags before the browser submits normally.
  populateFormData(form);
}

function calculateResults() {
  chakraScores = [];
  
  quizData.chakras.forEach((chakra, index) => {
    const chakraAnswers = answers[index];
    const score = chakraAnswers.reduce((sum, val) => sum + val, 0);
    
    // Score range: 0-21 (7 questions × 0-3 points each)
    let status;
    if (score >= 19) status = 'overactive';      // 19-21: Too much energy
    else if (score >= 15) status = 'balanced';   // 15-18: Balanced
    else if (score >= 8) status = 'underactive'; // 8-14: Needs activation
    else status = 'blocked';                     // 0-7: Blocked
    
    chakraScores.push({
      chakra: chakra,
      score: score,
      status: status
    });
  });
}

function populateFormData(form) {
  const formData = new FormData(form);
  const name = String(formData.get('sattva_name') || '').trim();
  const [firstName, ...lastName] = name.split(/\s+/);
  document.getElementById('firstName').value = firstName || '';
  document.getElementById('lastName').value = lastName.join(' ');

  const clean = value => value.replace(/[,|=]/g, ' ').trim().slice(0, 40);
  const phone = clean(String(formData.get('sattva_phone') || ''));
  const location = clean(String(formData.get('sattva_location') || ''));
  const focus = chakraScores.reduce((current, item) =>
    Math.abs(item.score - 16.5) > Math.abs(current.score - 16.5) ? item : current
  );
  const tagHandle = chakra => chakra.id.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);
  const tagParts = chakraScores.map(({ chakra, score }) => `${tagHandle(chakra)}=${score}`);
  tagParts.push(`focus=${tagHandle(focus.chakra)}`);
  if (phone) tagParts.push(`phone=${phone}`);
  if (location) tagParts.push(`loc=${location}`);

  const readingTag = `sattva-quiz:${tagParts.join('|')}`.slice(0, 255);
  const answerTag = `sattva-quiz-answers:${quizData.chakras.map((_, index) => answers[index].join('')).join('')}`;
  const tagsField = form.querySelector('#quizTags');
  tagsField.value = ['sattva-quiz', `sattva-quiz-focus-${tagHandle(focus.chakra)}`, readingTag, answerTag].join(',');
}

function storeResultsInSession() {
  // Store all quiz data in sessionStorage
  const quizData = {
    answers: answers,
    scores: chakraScores,
    timestamp: new Date().toISOString()
  };
  
  sessionStorage.setItem('chakraQuizResults', JSON.stringify(quizData));
  console.log('Results stored in session');
}

function loadResultsFromSession() {
  const stored = sessionStorage.getItem('chakraQuizResults');
  if (!stored) return false;
  
  try {
    const quizData = JSON.parse(stored);
    answers = quizData.answers;
    chakraScores = quizData.scores;
    
    console.log('Results loaded from session');
    return true;
  } catch (e) {
    console.error('Error loading results:', e);
    return false;
  }
}

function displayResults() {
  const container = document.getElementById('chakraResults');
  if (!container) return;
  
  container.innerHTML = '';
  
  // Default fallback content
  const defaultResults = {
    blocked: {
      description: "This chakra may be blocked. Consider focusing on practices to restore balance.",
      affirmation: "I am open to healing and balance.",
      tip: "Take time for self-reflection and gentle energy work."
    },
    underactive: {
      description: "This chakra is underactive. It needs gentle activation and attention.",
      affirmation: "I welcome positive energy and balance.",
      tip: "Focus on activities that activate this energy center."
    },
    balanced: {
      description: "This chakra is balanced and functioning well. Keep up your current practices!",
      affirmation: "I maintain harmony and balance.",
      tip: "Continue your current wellness routine."
    },
    overactive: {
      description: "This chakra is overactive. Consider grounding and calming practices.",
      affirmation: "I find balance in all things.",
      tip: "Practice grounding and centering exercises."
    }
  };
  
  chakraScores.forEach(({ chakra, score, status }) => {
    const resultData = chakra.results[status];
    
    // Get content from blocks or use defaults
    const description = (resultData && resultData.description && resultData.description.trim()) 
      ? resultData.description 
      : defaultResults[status].description;
    
    const affirmation = (resultData && resultData.affirmation && resultData.affirmation.trim()) 
      ? resultData.affirmation 
      : defaultResults[status].affirmation;
    
    const tip = (resultData && resultData.tip && resultData.tip.trim()) 
      ? resultData.tip 
      : defaultResults[status].tip;
    
    const card = document.createElement('div');
    card.className = 'chakra-result-card';
    card.style.borderLeftColor = chakra.color;
    
    // Parse candles
    const candles = chakra.candles && chakra.candles.trim() 
      ? chakra.candles.split(',').map(c => c.trim()).filter(c => c) 
      : [];
    
    const candleList = candles.map(candle => `<li>${candle}</li>`).join('');
    
    card.innerHTML = `
      <div class="chakra-result-header">
        <h3 class="chakra-result-name">${chakra.emoji} ${chakra.name}</h3>
        <span class="chakra-result-status status-${status}">${status.toUpperCase()}</span>
      </div>
      <p class="chakra-result-description">${description}</p>
      ${affirmation ? `
        <div class="chakra-result-affirmation" style="background: ${chakra.color}15; border-left-color: ${chakra.color};">
          <div class="affirmation-icon">✨</div>
          <div class="affirmation-text">${affirmation}</div>
        </div>
      ` : ''}
      ${tip ? `
        <div class="chakra-result-tip">
          <strong>💡 Support Tip:</strong> ${tip}
        </div>
      ` : ''}
      ${candles.length > 0 ? `
        <div class="candle-recommendations">
          <p class="candle-recommendations-title">🕯️ Suggested Sattva Candles:</p>
          <ul class="candle-list">
            ${candleList}
          </ul>
        </div>
      ` : ''}
    `;
    
    container.appendChild(card);
  });
}

function retakeQuiz() {
  currentChakraIndex = 0;
  
  // Reset answers
  quizData.chakras.forEach((chakra, index) => {
    answers[index] = new Array(7).fill(null);
  });
  
  userData = {};
  chakraScores = [];
  
  // Reset form
  document.getElementById('quizForm').reset();
  
  // Show welcome screen
  showScreen('welcome');
}